const injectScript = (url, options = {}) => {
    const script = document.createElement('script');
    script.src = url;
    Object.assign(script, options);
    document.body.appendChild(script);
};

export default injectScript;
